import './styles.scss';
import React, {useEffect, useState} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../constants";

/* Bootstrap */

/* Redux */
import {useSelector} from "react-redux";
import {TSavedDocument, ISavedState} from "../../../types/redux/saved";
import {RootState} from "../../../redux";

/* Components */
import TagsModal from "../../tags-notes/tags/tag-modal";
import Tags from "../../tags-notes/tags/tags";
import Note from "../../tags-notes/notes";
import Save from "../../toolbars/components/save";
import {IViewerState} from "../../../types/redux/viewer";

const ViewerTagsNotes = ():JSX.Element => {

  /* redux */
  const saveState: ISavedState = useSelector<RootState, ISavedState>(state => state.saved);
  const record: any = useSelector<RootState, IViewerState>(state => state.viewer).viewerRecord;

  /* state */
  const [savedDocumentData, setSavedDocumentData] = useState<TSavedDocument | null>(null);
  const [dateSaved, setDateSaved] = useState<string>();

  useEffect(()=>{
    if (!document) return;

    const savedDocumentData: TSavedDocument | undefined = saveState.documents.find(savedDocument => savedDocument.documentId === record.id);
    setSavedDocumentData( savedDocumentData ? savedDocumentData : null)
    if (savedDocumentData) {
      setDateSaved(new Date(savedDocumentData.dateCreated).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}))
    }

  }, [saveState.documents, record.id])

  return  (
    <div className={'viewer-saved position-relative px-2 mt-2'}>
      {/* Note */}
      <div className={'doc-note doc-content mb-0 mt-3'}>
        <Note context={Constants.DOCUMENT}/>
      </div>

      {/* Tags display */}
      {(savedDocumentData !== null) &&
        (savedDocumentData.tags.length > 0) &&
        <div className={'mb-4 mt-3'}>
          <Tags appliedTags={savedDocumentData?.tags}/>
        </div>}

      {/* Add to Library */}
      <Save context={Constants.DOCUMENT}/>

      {/* Tags modal */}
      <div className={'doc-tags mt-2'}>
        <TagsModal appliedTags={savedDocumentData?.tags}/>
      </div>

      {dateSaved && <div className={'text-secondary mt-3 text-smaller'}>Saved on {dateSaved}</div>}
    </div>
  )
}
export default ViewerTagsNotes;
